"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Interview = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Interview = function Interview(_ref) {
  var question = _ref.question,
      answer = _ref.answer;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Content, null, _react.default.createElement("aside", null, _react.default.createElement(_styles.Sticky, null, _react.default.createElement(_styles.Question, null, question))), _react.default.createElement(_styles.Answer, null, answer)));
};

exports.Interview = Interview;